import React from 'react'
import { getPalette } from '../../styles/palette'
import { StyledThemeProvider } from '../../utilities'

const ThemeProvider = (props = {}) => {
    const { theme, children } = props
    const palette = getPalette(theme)

    return <StyledThemeProvider theme={palette}>
        {children}
    </StyledThemeProvider>
}

export default ThemeProvider